export enum AuthStatesEnum {
  login = 'login',
  signup = 'signup',
  resetPassword = 'resetPassword',
  setPassword = 'setPassword',
}
